import { Link } from "gatsby";
import React from "react";
import Style from "styles/components/owned_media.module.scss";


const MediaPresenter = ({ items }) => (
  <section className={Style.ownedMedia}>
    {items.length > 0 && (
      <div>
        <h2 className={Style.ownedMedia__title}>
          <span>BLOG</span>
        </h2>
        <div className={Style.gridContainer}>
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/know_how_detail/?id=${item.id}`}
              className={Style.mediaCard}
            >
              <img src={item.thumbnailImage} alt={item.title} />
              <div className={Style.mediaCard__content}>
                <div className={Style.categoryContainer}>
                  {item.category?.map((cat) => (
                    <div
                      key={cat.name}
                      style={{ backgroundColor: cat.color }}
                    >
                      {cat.name}
                    </div>
                  ))}
                </div>
                <div className={Style.mediaCard__meta}>{item.publishDate}</div>
                <div className={Style.mediaCard__title}>{item.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    )}
  </section>
);

const Media = ({items}) => {
  const list = Array.isArray(items) ? items : [];
  return <MediaPresenter items={list} />;
};

export default Media;
